import fetch from 'isomorphic-unfetch'
import cookies from 'js-cookie'

import { ReceiptLines } from '@/app/types'
import downloadConfig from '@/config/download'

export const downloadBlob = (blob: Blob, filename: string) => {
  const obj = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = obj
  a.download = filename
  document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
  a.click()
  a.remove()
}

export const downloadFile = async (url: string, filename: string, isSigned = false, download = true) => {
  const headers: Record<string, string> = {}

  if (!isSigned) {
    const token = cookies.get('authToken')
    headers.Authorization = `JWT ${token}`
  }

  const response = await fetch(url, {
    method: 'GET',
    headers,
  })

  if (!response.ok) {
    throw new Error('Failed to download file')
  } else {
    const blob = await response.blob()

    if (!download) {
      return blob
    }

    downloadBlob(blob, filename)
    return blob
  }
}

const downloadService = {
  exports: (orgId: number, exportId: number, filename: string) => {
    const url = downloadConfig.exports.getPath({ orgId, exportId, filename })
    return downloadFile(url, filename)
  },
  files: (orgId: number, filename: string, download = true) => {
    const url = downloadConfig.files.getPath({ orgId, filename })
    return downloadFile(url, filename, false, download)
  },
  invoices: (orgId: number, filename: string, lines?: ReceiptLines) => {
    const url = downloadConfig.invoices.getPath({ orgId, filename, lines })
    return downloadFile(url, filename)
  },
  receipts: (orgId: number, transactionId: number, lines: ReceiptLines) => {
    const filename = downloadConfig.receipts.getFileName(transactionId)
    const url = downloadConfig.receipts.getPath({ orgId, transactionId, lines })
    return downloadFile(url, filename)
  },
  recordings: (orgId: number, recordingId: number, download = true) => {
    const url = downloadConfig.recordings.getPath({ orgId, recordingId })
    return downloadFile(url, `call-recording-${recordingId}.mp3`, false, download)
  },
}

export default downloadService
